"use client";

import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import DataTypeCombobox, { DataTypesProvider } from '@/components/ui/DataTypeCombobox';

export function DataTypeComboboxExample() {
  const [selectedTypes, setSelectedTypes] = useState<string[]>([]);

  return (
    <DataTypesProvider>
      <Card className="w-full max-w-xl mx-auto my-8">
        <CardHeader>
          <CardTitle>DataTypeCombobox Example</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="mb-4">
            <Label>Choose Data Types</Label>
            <DataTypeCombobox
              selected={selectedTypes}
              setSelected={setSelectedTypes}
              placeholder="Select data types..."
              fullWidth
            />
          </div>
          <div className="mt-4">
            <Label>Selected Data Types:</Label>
            <div className="flex flex-wrap gap-2 mt-2">
              {selectedTypes.length === 0 ? (
                <span className="text-muted-foreground">None selected</span>
              ) : (
                selectedTypes.map((id) => (
                  <Badge key={id}>{id}</Badge>
                ))
              )}
            </div>
          </div>
        </CardContent>
      </Card>
    </DataTypesProvider>
  );
}

export default DataTypeComboboxExample;
